import moment from 'moment';
import axios from 'axios';
const config = require('config');

export default {
  async getStoreList(context, { brand, region = '' }) {
    try {
      let link = `/smartphone/service-center/${brand}`;
      if (region) link = link + `?region=${region}`;
      let response = await this.$axios.get(link);
      const { data } = response.data;
      context.commit('updateStoreList', data);
      return data;
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },

  async getPolicyData(context, { page }) {
    const startDate = moment()
      .add(-1, 'years')
      .format('YYYY-MM-DD');
    const endDate = moment()
      .add(+1, 'years')
      .format('YYYY-MM-DD');

    const codeCountry = await context.rootGetters['general/getCountryCode'];
    let APIPath = '/policies';
    if (codeCountry === 'VN') APIPath = `${APIPath}/list?&page=${page}&country=${codeCountry}`;
    else APIPath = `${APIPath}?sortDirection=desc&limit=7&page=${page}&startDate=${startDate}&endDate=${endDate}`;
    try {
      const { data } = await this.$axios.get(APIPath);
      const response = data;
      const policies = context.getters['getPolicies'];

      if (policies) {
        if (response === policies) return true;
        if (response.meta.page > policies.meta.page) {
          response.data = policies.data.concat(response.data);
        }
        context.commit('updatePolicies', response);
      } else {
        context.commit('updatePolicies', response);
      }
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData;
    }
  },
  async getPolicyDetail(context, { policyType, policyNumber, callback = () => null }) {
    let type = policyType;

    switch (type) {
      case 'flight':
        type = 'travel';
        break;
      case 'healthDBD':
        type = 'dbd';
        break;
      case 'accommodation':
        type = 'accomm';
        break;
      case 'electronic':
        type = 'electronic';
        break;
      default:
        break;
    }
    try {
      let link;
      switch (type) {
        case 'dbd':
          link = `/health/policies/${type}/${policyNumber}`;
          break;
        case 'accomm':
          link = `/${type}/policies/${policyNumber}`;
          break;
        case 'hcp-partnership':
          link = `/health/hcp/policies/${policyNumber}`;
          break;
        case 'vehicle':
        case 'life':
        case 'health':
        case 'hcp':
        case 'tropical-disease':
          link = `/policies/${policyNumber}`;
          break;
        default:
          link = `/${type}/policies/${policyNumber}`;
          break;
      }
      const { data } = await this.$axios.get(link);
      const response = data.data;
      context.commit('updatePolicy', response);
      return callback();
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async searchPolicy(context, { type, pnr, channel = '', additionalType = '', callback }) {
    try {
      let link;
      if (type === this.app.i18n.t('add_policy_option1')) {
        link = '/train/policies/booking-code/';
      } else if (type === this.app.i18n.t('add_policy_option3')) {
        console.log(additionalType);
        if (additionalType === 'Qoala') {
          link = '/smartphone/policies/transaction-id/';
        } else {
          link = '/smartphone/policies/imeis/';
        }
      } else if (type === this.app.i18n.t('add_policy_option6')) {
        link = '/smartphone/policies/serial-number/';
      } else if (type === this.app.i18n.t('add_policy_option4')) {
        link = '/bus/policies/booking-code/';
      } else if (type === this.app.i18n.t('add_policy_option5')) {
        link = '/health/policies/dbd/search/';
      } else if (type === this.app.i18n.t('add_policy_option7')) {
        link = '/accomm/policies/search/';
      } else if (type === this.app.i18n.t('add_policy_car')) {
        link = '/policies/search/';
        pnr = pnr + '?productType=car&productCategory=vehicle';
      } else if (type === this.app.i18n.t('add_policy_motor')) {
        link = '/policies/search/';
        pnr = pnr + '?productType=motor&productCategory=vehicle';
      } else if (type === this.app.i18n.t('add_policy_health')) {
        link = '/policies/search/';
        pnr = pnr + '?productCategory=health';
      } else if (type === this.app.i18n.t('add_policy_hcp')) {
        link = '/policies/search/';
        pnr = pnr + '?productBenefit=hcp&productCategory=health';
      } else if (type === this.app.i18n.t('add_policy_life')) {
        link = '/policies/search/';
        pnr = pnr + '?productBenefit=TL&productCategory=life';
      } else if (type === this.app.i18n.t('add_policy_tdp')) {
        link = '/policies/search/';
        pnr = pnr + '?productBenefit=td&productCategory=health';
      } else if (type === this.app.i18n.t('add_policy_jdid_hcp')) {
        link = '/health/hcp/policies/invoice-number/';
      } else if (type === this.app.i18n.t('add_policy_ovo_hcp')) {
        link = '/health/hcp/policies/insurance-number/';
      } else if (type === this.app.i18n.t('add_policy_momo_smartphone')) {
        link = '/smartphone/policies/imeis/';
      } else if (type === this.app.i18n.t('add_policy_bkk_hcp')) {
        link = '/health/hcp/policies/insurance-number/';
      } else {
        link = '/travel/policies/booking-code/';
      }
      const { data } = await this.$axios.get(link + pnr + (channel ? channel : ''));
      const response = data.data;
      callback(response);
    } catch (error) {
      console.log('error searchPnr', error);
    }
  },
  async getClaimData(context, { page }) {
    try {
      const query = `orderBy=updatedAt&&sortDirection=desc&&limit=7&&page=${page}`;
      const { data } = await this.$axios.get(`/claims?${query}`);
      const response = data;
      const claims = context.getters['getClaims'];
      if (claims) {
        response.data = claims.data.concat(response.data);
        context.commit('updateClaims', response);
      } else {
        context.commit('updateClaims', response);
      }
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData;
    }
  },
  async getClaimDetail(context, { typeClaim, number, callback, callbackFail }) {
    try {
      let link;
      if (typeClaim === 'train') {
        link = '/train/claims/';
      } else if (typeClaim === 'smartphone') {
        link = '/smartphone/claims/';
      } else if (typeClaim === 'bus') {
        link = '/bus/claims/';
      } else if (typeClaim === 'healthDBD') {
        link = '/health/claim/';
      } else if (typeClaim === 'accommodation') {
        link = '/accomm/claims/';
      } else if (typeClaim === 'electronic') {
        link = '/electronic/claims/';
      } else if (typeClaim === 'vehicle') {
        link = '/mv/claims/';
      } else if (typeClaim === 'hcp-partnership') {
        link = '/health/hcp/claims/';
      } else {
        link = '/travel/claims/';
      }
      const { data } = await this.$axios.get(link + number);
      const response = data.data;
      context.commit('updateClaim', response);
      return callback();
    } catch (error) {
      const errorResponse = error.response;
      let errorMessage;
      if (errorResponse) {
        errorMessage = errorResponse.data ? errorResponse.data.message : '';
      }
      if (callbackFail) {
        callbackFail(errorMessage || '');
      }
    }
  },
  async claimRating(context, { rates, callbackSuccess, callbackFail }) {
    try {
      await this.$axios.put('/claims/rate', rates);
      callbackSuccess();
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      callbackFail(errorData.message);
    }
  },
  async claimAppeals(context, { appeal, callbackSuccess, callbackFail }) {
    try {
      await this.$axios.put('/claims/appeal', appeal);
      callbackSuccess();
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      callbackFail(errorData.message);
    }
  },
  async smartPhoneDelivered(context, { payload, callbackSuccess, callbackFail }) {
    let link = 'https://dev-alb.qoala.app:3010/api/claims/';
    if (process.env.NODE_ENV === 'production') link = 'https://dashboard.qoala.app:3010/api/claims/';
    try {
      const { data } = await this.$axios.put(link, payload);
      callbackSuccess();
      const response = data.data;
      this.commit('updateClaim', response);
    } catch (error) {
      callbackFail(error.message);
    }
  },
  async smartPhoneRating(context, { rates, callbackSuccess, callbackFail }) {
    try {
      await this.$axios.put('/smartphone/claims/rate', rates);
      callbackSuccess();
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      callbackFail(errorData.message);
    }
  },
  async registerPolicy(context, { type, number, products }) {
    try {
      let link;
      let response;
      switch (type) {
        case this.app.i18n.t('add_policy_option1'):
          link = '/train/policies/register-policy';
          break;
        case this.app.i18n.t('add_policy_option3'):
        case this.app.i18n.t('add_policy_option6'):
        case this.app.i18n.t('add_policy_momo_smartphone'):
          if (products) {
            link = '/electronic/policies/register';
            response = await this.$axios.post(link, products);
            return response.data;
          }
          link = '/smartphone/policies/add';
          break;
        case this.app.i18n.t('add_policy_option4'):
          link = '/bus/policies/register-policy';
          break;
        case this.app.i18n.t('add_policy_option5'):
          link = '/health/policies/add';
          break;
        case this.app.i18n.t('add_policy_option7'):
          link = '/accomm/policies/add';
          break;
        case this.app.i18n.t('add_policy_car'):
        case this.app.i18n.t('add_policy_motor'):
        case this.app.i18n.t('add_policy_health'):
        case this.app.i18n.t('add_policy_hcp'):
        case this.app.i18n.t('add_policy_life'):
        case this.app.i18n.t('add_policy_tdp'):
          link = '/policies/add';
          break;
        case this.app.i18n.t('add_policy_jdid_hcp'):
        case this.app.i18n.t('add_policy_ovo_hcp'):
        case this.app.i18n.t('add_policy_bkk_hcp'):
          link = '/health/hcp/policies/register';
          break;
        default:
          link = '/travel/policies/register-policy';
          break;
      }
      const { data } = await this.$axios.post(link, {
        number
      });
      return data;
    } catch (error) {
      console.log('error registPnr', error);
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData.message;
    }
  },
  async submitClaim(context, { policyType, dataSend }) {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    context.commit('updateCancelToken', source);
    let link;
    if (policyType === 'train') {
      link = '/train/claims/';
    } else if (policyType === 'smartphone') {
      // link = 'https://dev-alb.qoala.app:3010/api/claims/';
      link = 'https://api-staging.qoala.app/api/smartphone/v1/claims';
      if (process.env.NODE_ENV === 'production') link = 'https://api.qoala.app/api/smartphone/v1/claims';
    } else if (policyType === 'healthDBD') {
      link = 'https://dev-alb.qoala.app:3007/api/claim';
      if (process.env.NODE_ENV === 'production') link = 'https://dashboard.qoala.app:3007/api/claim';
    } else if (policyType === 'bus') {
      link = '/bus/claims/';
    } else if (policyType === 'accommodation') {
      link = `${config.apiBaseUrl}/accomm/claims`;
    } else if (policyType === 'vehicle') {
      link = 'https://api-staging.qoala.app/api/mv/claims';
    } else {
      link = '/travel/claims/';
    }
    try {
      const { data } = await this.$axios.post(link, dataSend, {
        timeout: Infinity,
        cancelToken: source.token
      });
      if (policyType === 'smartphone') {
        return data.data;
      }
      return data;
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        if (data) this.$sentry.captureMessage(`ERROR CLAIM  ${JSON.stringify(data)}`);
      }
      return error;
    }
  },
  async updateDocument(context, { typeClaim, dataSend, callback, callbackFail, claimNumber }) {
    let link;
    if (typeClaim === 'train') {
      link = '/train/claims/';
    } else if (typeClaim === 'smartphone') {
      link = '/smartphone/claims/';
    } else if (typeClaim === 'bus') {
      link = '/bus/claims/';
    } else if (typeClaim === 'healthDBD') {
      link = '/dbd/claims/';
    } else if (typeClaim === 'accommodation') {
      link = '/accomm/claims/' + claimNumber;
    } else if (typeClaim === 'vehicle') {
      link = '/mv/claims/' + claimNumber;
    } else {
      link = '/travel/claims/';
    }
    const userToken = context.rootGetters['user/getUserToken'];
    const header = {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    };
    try {
      const { data } = await axios.put(config.apiBaseUrl + link, dataSend, header);
      const response = data.data;
      return callback(response);
    } catch (error) {
      return callbackFail(error);
    }
  },
  async getUpcomingFlight(context, { callback, callbackFail }) {
    try {
      const { data } = await this.$axios.get('/home/recent-upcoming');
      const response = data.data;
      context.commit('updateUpcoming', response);
      callback();
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      callbackFail(errorData.message);
    }
  },
  async getSmartPhoneProduct(context, params) {
    const token = context.rootGetters['user/getUserToken'];
    try {
      let data;
      if (token) {
        data = await this.$axios.post('/smartphone/check-product', params);
      } else {
        data = await axios.post(`${process.env.API_BASE_URL}/smartphone/check-product`, params);
      }
      const response = data.data.data;
      context.commit('updateSmartPhoneProduct', response);
      return response;
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  // async prepareCustomer(context, params) {
  //   const token = context.rootGetters['user/getUserToken'];
  //   try {
  //     let data;
  //     if (token) {
  //       data = await this.$axios.post('/smartphone/prepare-customer', params);
  //     } else {
  //       data = await axios.post(`${process.env.API_BASE_URL}/smartphone/prepare-customer`, params);
  //     }
  //     if (data) {
  //       const response = data.data.data;
  //       console.log('prepareCustomer response', response);
  //       context.commit('updatePurchaseConfirmation', response);
  //       return response;
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     throw err;
  //   }
  // },
  async purchasePolicy(context, params) {
    const token = context.rootGetters['user/getUserToken'];
    const paramsPrepare = {
      full_name: params.full_name,
      email: params.email,
      phone_number: params.phone_number,
      product_code: params.product_code
    };
    const paramsPurchase = {
      payment_method: params.payment_method,
      product_code: params.product_code,
      type: params.type,
      identifier: params.identifier,
      promo_codes: params.promo_codes
    };
    try {
      let data;
      if (token) {
        data = await this.$axios.post('/smartphone/prepare-customer', paramsPrepare);
      } else {
        data = await axios.post(`${process.env.API_BASE_URL}/smartphone/prepare-customer`, paramsPrepare);
      }
      if (data) {
        const token = data.data.data.token;
        try {
          let data;
          let config = {
            headers: {
              Authorization: `Bearer ${token}`
            }
          };
          data = await axios.post(`${process.env.API_BASE_URL}/smartphone/purchase`, paramsPurchase, config);
          const response = data.data.data;
          context.commit('updatePurchasePayment', response);
          return response;
        } catch (error) {
          const { data } = error.response;
          if (data)
            this.$sentry.captureMessage(
              `ERROR POLICY CREATION RES: ${JSON.stringify(data)} REQ: ${JSON.stringify(params)}`
            );
          // const { data } = error.response;
          // if (data) this.$sentry.captureException(new Error(`ERROR ON POLICY CREATION ${JSON.stringify(data)}`));
        }
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
    // const purchaseConfirm = context.getters.getPurchaseConfirmation;
    // try {
    //   let data;
    //   let config = {
    //     headers: {
    //       Authorization: `Bearer ${purchaseConfirm.token}`
    //     }
    //   };
    //   data = await axios.post(`${process.env.API_BASE_URL}/smartphone/purchase`, params, config);
    //   const response = data.data.data;
    //   context.commit('updatePurchasePayment', response);
    //   return response;
    // } catch (error) {
    //   const { data } = error.response;
    //   if (data) this.$sentry.captureException(new Error(`ERROR ON POLICY CREATION ${JSON.stringify(data)}`));
    // }
  },
  async getDocumentPresignLink(context, payload) {
    try {
      const response = await this.$axios.post('/accomm/documents/get-upload-url', payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  async getDocumentPresignLinkSmartphone(context, payload) {
    try {
      const response = await this.$axios.post('/smartphone/v1/claims/presigned?type=claims', payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  async smartphoneHitPresignUrl(context, { video, url }) {
    try {
      const response = await this.$axios.put(url, video);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async getPolicyByProductCode(context, productCode) {
    try {
      const { data } = await this.$axios.get(`/accomm/products/${productCode}`);
      const response = data.data;
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async getBusPresignLink(context, payload) {
    try {
      const response = await this.$axios.post('/bus/claims/presigned', payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  async submitBusClaim(context, payload) {
    try {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      context.commit('updateCancelToken', source);
      const { data } = await this.$axios.post(`/bus/claims`, payload, {
        timeout: Infinity,
        cancelToken: source.token
      });
      return data;
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        if (data) this.$sentry.captureMessage(`ERROR CLAIM  ${JSON.stringify(data)}`);
      }
      throw error;
    }
  },
  async documentsResubmitPresign(context, payload) {
    try {
      const response = await this.$axios.post('bus/claim-histories/presigned', { resubmitDocuments: payload });
      return response.data;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  async resubmitBusClaim(context, { payload, number }) {
    try {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      context.commit('updateCancelToken', source);
      const { data } = await this.$axios.post(`/bus/claim-histories/${number}`, payload, {
        timeout: Infinity,
        cancelToken: source.token
      });
      return data;
    } catch (error) {
      throw error;
    }
  },
  async createPolicy(context, payload) {
    const userToken = context.rootGetters['user/getUserToken'];
    try {
      let data;
      let config = {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      };
      data = await axios.post(`${process.env.API_BASE_URL}/policies`, payload, config);
      const response = data.data.data;
      return response;
    } catch (error) {
      const { data } = error.response;
      if (data)
        this.$sentry.captureMessage(
          `ERROR POLICY CREATION RES: ${JSON.stringify(data)} REQ: ${JSON.stringify(payload)}`
        );
      return false;
    }
  },
  async getPolicyList(context, { query }) {
    try {
      const { data } = await this.$axios.get(`${process.env.API_BASE_URL}/policies/list?limit=100&${query}`);
      const response = data.data;
      context.commit('updatePolicyList', response);
      return response;
    } catch (err) {
      return err;
    }
  },
  async getHCPPartnershipPresignLink(context, payload) {
    try {
      const response = await this.$axios.post('/health/hcp/claims/presigned', { documents: payload });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async submitHCPPartnershipClaim(context, payload) {
    try {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      context.commit('updateCancelToken', source);
      const { data } = await this.$axios.post(`/health/hcp/claims`, payload, {
        timeout: Infinity,
        cancelToken: source.token
      });
      return data;
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        if (data) this.$sentry.captureMessage(`ERROR CLAIM  ${JSON.stringify(data)}`);
      }
      throw error;
    }
  },
  async resubmitHCPPartertnsipClaim(context, { payload, number }) {
    try {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      context.commit('updateCancelToken', source);
      const { data } = await this.$axios.put(`/health/hcp/claims/${number}`, payload, {
        timeout: Infinity,
        cancelToken: source.token
      });
      return data;
    } catch (error) {
      throw error;
    }
  },
  async checkPolicyList(context, { identifier, codeCountry = 'ID' }) {
    const endpoint = `/policies/check?identifier=${identifier}&country=${codeCountry}`;
    try {
      const { data } = await this.$axios.get(endpoint);
      const response = data.data;
      return response;
    } catch (error) {
      throw error;
    }
  },
  async addBulkPolicy(context, { identifier }) {
    try {
      const { data } = await this.$axios.post('/policies/add/bulk', { identifier });
      const response = data.data;
      return response;
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  async validateLimitPolicy(context, { payload }) {
    try {
      const response = await axios.post(`${process.env.API_BASE_URL}/policies/validate`, payload);
      return response;
    } catch (error) {
      return error;
    }
  },
  async updatePolicyDocument(context, { payload, transactionNumber, product }) {
    const userToken = context.rootGetters['user/getUserToken'];
    const header = {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    };
    try {
      const response = await axios.post(
        `${process.env.API_BASE_URL}/policies/${product}/${transactionNumber}/update-policy`,
        payload,
        header
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
};
